import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";
Vue.use(VueMeta);
import VueLocalStorage from "vue-localstorage";
Vue.use(VueLocalStorage);
import localStorage from "./storage";
import { createI18n } from "./locale";

import { Locale } from "vant";
import enUS from "vant/es/locale/lang/en-US";
Locale.use("en", enUS);

Vue.config.productionTip = false;

import {aegisInit} from "@mono/utils";

export const vueInit = async () => {
  const i18nInstance = await createI18n();
  const aegis = await aegisInit(true, false, false, true);
  /* eslint-disable no-new */
  new Vue({
    localStorage,
    router,
    store,
    i18n: i18nInstance,
    aegis: aegis,
    render: (h) => h(App),
    created() {
      const langCode = this.$i18n.locale;
      if (langCode == "ar") {
        document.documentElement.setAttribute("dir", "rtl");
      } else {
        document.documentElement.setAttribute("dir", "ltr");
      }
    },
  }).$mount("#app");
};
